import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal} from 'components';
import {TRANSLATION_KEYS} from 'locale';

import {AppointmentClientNotificationAction} from '../types';

type Props = {
    open: boolean;
    action?: AppointmentClientNotificationAction;
    callback?: (confirm: boolean) => void;
    onClose: (confirm: boolean, callback: (confirm: boolean) => void) => void;
};

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.APPOINTMENTS.NOTIFY_PARTICIPANTS_MODAL;
const T_KEYS_COMMON = TRANSLATION_KEYS.COMMON;

export const NotifyParticipantsModal = ({open, action, callback, onClose}: Props) => {
    const {t} = useTranslation();

    const message = useMemo(() => {
        if (action === AppointmentClientNotificationAction.Create) {
            return t(T_KEYS.LABELS.CREATED);
        } else if (action === AppointmentClientNotificationAction.Update) {
            return t(T_KEYS.LABELS.UPDATED);
        } else if (action === AppointmentClientNotificationAction.Delete) {
            return t(T_KEYS.LABELS.DELETED);
        }
    }, [action, t]);

    const handleClose = useCallback((confirm) => {
        onClose(confirm, callback);
    }, [onClose, callback]);

    return (
        <ConfirmModal
            open={open}
            title={t(T_KEYS.TITLE)}
            fullWidth
            maxWidth='xs'
            okText={t(T_KEYS_COMMON.ALL.YES)}
            cancelText={t(T_KEYS_COMMON.ALL.NO)}
            onClose={handleClose}
        >
            {message}
            <div className='tw-mt-2'>{t(T_KEYS.MESSAGE)}</div>
        </ConfirmModal>
    );
};
